import { render, staticRenderFns } from "./securitybulletins.vue?vue&type=template&id=4f24ca4e&lang=pug"
import script from "./securitybulletins.vue?vue&type=script&lang=js"
export * from "./securitybulletins.vue?vue&type=script&lang=js"
import style0 from "./securitybulletins.vue?vue&type=style&index=0&id=4f24ca4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports